import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../../../imageService';

// Усі ассети цього флоу лежать в одній папці на S3.
const IMAGES_PATH = 'images/sms-feedback/26ua-prl-sign';

// Градієнт дублюється тут, бо фон збирається двома шарами інлайном:
// картинка зверху, градієнт під нею (він видно, поки картинка вантажиться,
// і якщо в експорті буде прозорий фон).
const BACKGROUND_GRADIENT =
  'linear-gradient(180deg, #ac865d 0%, #a38d74 50%, #a38d74 100%)';

// Спільна «обгортка» всіх екранів опитувальника: фон і липкий хедер.
// Картинка хедера — тільки лого з написом (92x34 у макеті, експорт 2x),
// біла плашка під ним намальована стилями.
const Layout = ({ children, className, contentClassName }) => (
  <div
    className={classNames(styles.container, className)}
    style={{
      backgroundImage: `url("${getImageFromS3(
        `${IMAGES_PATH}/bg.png`
      )}"), ${BACKGROUND_GRADIENT}`
    }}
  >
    <div className={styles.header}>
      <img src={getImageFromS3(`${IMAGES_PATH}/header.png`)} alt="Signature" />
    </div>
    <div className={classNames(styles.content, contentClassName)}>
      {children}
    </div>
  </div>
);

export { IMAGES_PATH };
export default Layout;
